<template>
<div>
  <div class="page-header">
    <div class="page-leftheader">
      <div class="headline"><h4 class="page-title text-primary">Benutzer</h4 ></div>
    </div>
    <div class="page-rightheader">
        <a
          class="btn btn-primary btn-pill mr-1"
          @click="$router.push('users')"
          >zurück</a
        >
        <a class="btn btn-primary btn-pill" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-calendar me-2 fs-14"></i> Nach Datum filtern</a>
        <div class="dropdown-menu border-0">
                <a class="dropdown-item" id="dropdownToday" @click="setTimePicker('Today')">Letzte 24 Stunden</a>
                <a class="dropdown-item" id="dropdownLastWeek" @click="setTimePicker('LastWeek')">Letzte 7 Tage</a>
                <a class="dropdown-item" id="dropdownLastMonth" @click="setTimePicker('LastMonth')">Letzte 30 Tage</a>
                <a class="dropdown-item active" id="dropdownAllTime" @click="setTimePicker('AllTime')">Gesamt</a>
        </div>
    </div>
    
  </div>
  <div>
    <div>
        <input v-model="search" type="search" class="form-control form-control-sm" placeholder="Suche..." aria-controls="example1">
        <br>
    </div> 
    <div>
      <div>
        <div class="card">
          <div class="table-responsive">
            <table class="table card-table table-vcenter text-nowrap">
              <thead>
                <tr>
                  <!--
                    WAR FALSCH: Der Sperreintrag liefert userName mit
                    (adminController.js speichert ihn ausdrücklich beim
                    Sperren), die Tabelle zeigte ihn aber nirgends an — nur
                    E-Mail und Telefonnummer. Bei den meisten Konten fehlt die
                    Telefonnummer, übrig blieb praktisch nur eine E-Mail-Adresse,
                    aus der man raten musste, wer gesperrt wurde.
                  -->
                  <th>Benutzername</th>
                  <th>E-Mail</th>
                  <th>Telefonnummer</th>
                  <th>Aktionen</th>
                </tr>
              </thead>
              <tbody>
              <!--
                Vier Zustände in EINER Kette: lädt · Abruf gescheitert · nichts
                gefunden · Ergebnisse.

                WAR FALSCH (Runde 1): Es gab nur "ist die Liste leer?" — das
                trifft VOR der Antwort genauso zu wie NACH einem Fehlschlag.
                "Keine gesperrten Nutzer gefunden." stand deshalb kurz beim
                Öffnen der Seite da und blieb bei einem gescheiterten Abruf
                dauerhaft stehen.

                WAR FALSCH (Runde 2): Die Zustandszeilen bildeten eine Kette,
                die Datenzeilen standen aber daneben und wurden immer
                gezeichnet. Nach einem gescheiterten Abruf stand die rote
                Fehlerzeile ÜBER der unveränderten alten Liste — der Bildschirm
                behauptete gleichzeitig "hat nicht geklappt" und zeigte
                Ergebnisse. Jetzt hängen die Datenzeilen als v-else an derselben
                Kette. Gleiche Lösung wie in Users.vue und Reported.vue.

                WICHTIG: Zwischen die Glieder dieser Kette gehört kein
                Kommentar — Vue verbindet v-else-if/v-else nur mit dem direkt
                davorstehenden Geschwisterelement (siehe ausführliche Notiz in
                Users.vue).
              -->
              <tr v-if="loading && users.length === 0">
                <td colspan="4" class="text-center text-muted">Wird geladen …</td>
              </tr>
              <tr v-else-if="fetchError">
                <td colspan="4" class="text-center text-danger">{{ fetchError }}</td>
              </tr>
              <tr v-else-if="users.length === 0">
                <td colspan="4" class="text-center text-muted">Keine gesperrten Nutzer gefunden.</td>
              </tr>
              <template v-else>
              <tr v-for="user in users" :key="user._id">
                <td class="align-middle">{{user.userName}}</td>
                <td class="align-middle">{{user.email}}</td>
                <td class="align-middle">{{user.telephoneNumber}}</td>
                <td>
                  <a class="btn btn-small btn-success" @click="openDeleteUser(user)" title="Benutzer wieder freischalten"><i class="fas fa-check"></i></a>
                </td>
              </tr>
              </template>
            </tbody>
            </table>
          </div>
        </div>
        <div style="position:absolute; bottom: 500px;left:50%;height:40px;width:40px " v-intersect.quiet="infiniteScrolling"></div>
      </div>
      </div>

      <!-- Dialog Nutzer entsperren. Der Knopf entfernt nur den Blacklist-
           Eintrag (deleteUser() ruft user/blacklist/delete/ auf), das
           Nutzerkonto selbst bleibt erhalten. Titel und Text sagten bisher
           "löschen" — das las sich wie eine Kontolöschung und nicht wie ein
           Entsperren. -->
      <v-dialog
        v-model="deleteDialog"
        width="500"
      >
        <v-card>
          <v-card-title class="card ">
            Benutzer entsperren
          </v-card-title>

          <v-card-text>
            <label class="form-label">Möchten Sie diesen Benutzer wirklich wieder freischalten (von der Sperrliste entfernen)?</label>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill mr-1" @click="deleteDialog=false">Abbrechen</a>
              <a class="btn btn-danger btn-pill" @click="deleteUser(editUser)">Entsperren</a>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
  
</div>
</template>

<script>
export default {

  components: {
  },

  data() {
    return {
      page: 0,
      totalPages: 1,
      ElementPerPage: 25,
      lastUsers: null,
      sort: null,
      order: true,
      routes: {
      },
      search: "",
      users: [],
      // Trennt "lädt gerade" von "wirklich leer" von "Abruf gescheitert" —
      // siehe Kommentar in fetchUser()/searchUser() und die Leerzeile im
      // Template.
      loading: false,
      fetchError: '',
      roles: [],

      menu: false,
      createmode: true,

      // Personal Data
      me: null,

      editUser: {
        userName: "",
        email: "",
        dateOfBirth: "",
        image: "",
        about: "",
        telephoneNumber: "",
        language: "",
        currentCoins: "",
        drivenKilometers: "",
        status: "",
        dateOfBirthObject: "",
      },

      editDialog: false,
      deleteDialog: false,
      emptyDialog: false,

      emptyValidation: false,
      deleteReason: '',
      currentTimeSpan: 'AllTime', // ENTS-9: Standard auf „Gesamt"
      // Verzögert die Suche um 300 ms, wie schon in Crews.vue. Ohne das ging
      // pro Tastendruck eine eigene Serveranfrage raus.
      searchTimer: null,
    };
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    // WAR FALSCH: Jeder Tastendruck löste sofort eine eigene Serveranfrage
    // aus. Jetzt wird wie in Crews.vue 300 ms gewartet und ein noch nicht
    // abgeschickter Zeitgeber verworfen, bevor ein neuer gesetzt wird.
    search : function(){
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        if(this.search == ""){
          this.fetchUser();
        }else{
          this.page = 0;
          this.searchUser();
        }
      }, 300);
    },
    editDialog: function () {
       if(this.editDialog == false) {
         this.emptyValidation = false;
         this.$forceUpdate();
       }
    }
  },

  beforeDestroy() {
    if (this.searchTimer) clearTimeout(this.searchTimer);
  },

  mounted() {
    this.fetchUser();
    // Hier standen zwei Kopien aus Users.vue: ein Aufruf von openEditUser() über
    // $route.params.user und ein Zuhörer auf $root.$on('Users'). Beide riefen
    // eine Methode auf, die es in dieser Datei nicht gibt, und der Zuhörer wurde
    // nie wieder abgemeldet (kein beforeDestroy). Folge: Nach einem Besuch der
    // Sperrliste warf jeder Treffer der Kopfzeilen-Suche auf der Nutzerseite
    // einen TypeError, weil der zurückgebliebene Zuhörer mitfeuerte.
    // Die Sperrliste hat keinen Bearbeiten-Dialog (nur "wieder freischalten"),
    // und App.vue sendet 'Users' ausschließlich auf der Route "Users" — der
    // Zuhörer konnte hier also nie sinnvoll greifen. Deshalb entfernt statt in
    // beforeDestroy abgemeldet; damit bleibt nichts zurück, was abzumelden wäre.
  },

  methods: {
    infiniteScrolling(entries, observer, isIntersecting) {
        if(isIntersecting){
            setTimeout(() => {
                var _this = this;
                if(this.lastUsers == this.ElementPerPage || this.lastUsers == null){
                  // WAR FALSCH: this.page wurde in beiden Zweigen VOR der
                  // Anfrage hochgezählt. Scheiterte sie (Netzstörung, 401,
                  // 500), blieb der Zähler trotzdem erhöht — die betroffenen
                  // 25 Einträge waren dauerhaft übersprungen, nur ein
                  // Neuladen der Seite half. Jetzt steigt die Seitenzahl erst
                  // NACH einer erfolgreichen Antwort, wie schon in Users.vue
                  // (naechsteSeite) und Models.vue.
                  const naechsteSeite = this.page + 1;
                  // WAR FALSCH: response.data.data wurde hier ungeprüft
                  // benutzt, obwohl fetchUser()/searchUser() dieselbe Antwort
                  // längst absichern. Bei einem fachlichen Fehlschlag (HTTP 200
                  // mit success:false) liefert dieses Backend gar kein
                  // data-Feld — der Zugriff auf .length warf dann, der Fehler
                  // landete still im .catch und das Nachladen blieb ohne
                  // Rückmeldung stehen. Beide Zweige benutzen jetzt denselben
                  // abgesicherten Anhänger.
                  const anhaengen = function (response) {
                    // Ein fachlicher Fehlschlag (HTTP 200 mit success:false)
                    // sah bisher exakt aus wie "die Liste ist zu Ende" und
                    // blieb stumm — während ein Netzfehler an derselben Stelle
                    // längst gemeldet wird (.catch -> onError). Jetzt beides
                    // gleich. Wie in Users.vue.
                    if (response.data != null && response.data.success === false) {
                      _this.lastUsers = 0;
                      _this.onError(response.data);
                      return;
                    }
                    const neue = (response.data && response.data.data) || [];
                    _this.lastUsers = neue.length;
                    if(neue.length >= 1) {
                      _this.page = naechsteSeite;
                      neue.forEach(item => _this.users.push(item));
                    }
                  };
                  if(this.search ==  "" || this.search == null){
                    this.$axios
                          .get('/user/blacklist/all/' + naechsteSeite * this.ElementPerPage + '/' + this.ElementPerPage + '/' + this.getCurrentTimeSpan())
                          .then(anhaengen)
                          .catch(_this.onError);
                  }
                  else{
                    // Auch beim Nachladen fehlte encodeURIComponent — ein
                    // Suchbegriff mit "/" oder "?" zerlegte den Pfad und die
                    // Anfrage lief in einen 404.
                    this.$axios.get('/user/blacklist/search/' + encodeURIComponent(this.search) +'/'+ naechsteSeite * this.ElementPerPage + '/' + this.ElementPerPage + '/' + this.getCurrentTimeSpan())
                          .then(anhaengen)
                          .catch(_this.onError);
                  }
                }
            }, 500);
        }
    },
    fetchUser() {
      var _this = this;
      // Der Zähler blieb beim Neuladen stehen: Wer vorher gescrollt hatte,
      // sprang beim nächsten Nachladen mitten in die Liste und übersprang alles
      // dazwischen.
      this.page = 0;
      // WAR FALSCH: Es gab keine "lädt gerade"-Anzeige und keine Trennung
      // zwischen "wirklich leer" und "Abruf ist fehlgeschlagen" — die
      // Leerzeile im Template ("Keine gesperrten Nutzer gefunden.") stand
      // dadurch auch WÄHREND des Ladens und bei einem Fehlschlag da. Wie in
      // Users.vue trennen loading/fetchError jetzt die drei Zustände.
      this.loading = true;
      this.fetchError = '';
      this.$axios.get('/user/blacklist/all/0/'+ this.ElementPerPage + '/' + this.getCurrentTimeSpan()).then(function(response){
        _this.loading = false;
        // WAR FALSCH: response.data.success wurde nicht geprüft. Bei einem
        // fachlichen Fehlschlag (HTTP 200, success:false) hat dieses Backend
        // KEIN data-Feld — users.length griff dann auf undefined zu.
        if (response.data == null || response.data.success === false) {
          _this.users = [];
          // Auf 0 statt unberührt: lastUsers steuert, ob beim Scrollen
          // nachgeladen wird. Blieb der alte Wert stehen, hängte das Nachladen
          // weiter Seiten an eine Liste, die wegen fetchError gar nicht
          // angezeigt wird.
          _this.lastUsers = 0;
          _this.fetchError = (response.data && response.data.message) || 'Der Server hat die Anfrage abgelehnt.';
          return;
        }
        _this.users = response.data.data || [];
        _this.lastUsers = _this.users.length;
      }).catch(function(error){
        _this.loading = false;
        // WAR FALSCH (Runde 2): Hier wurde nur fetchError gesetzt, die alte
        // Liste blieb stehen — Fehlermeldung und veraltete Trefferliste standen
        // danach gleichzeitig auf dem Bildschirm. Diese Abfrage ERSETZT die
        // Liste; scheitert sie, gibt es keine gültige Liste mehr.
        _this.users = [];
        _this.lastUsers = 0;
        _this.fetchError = _this.serverMessage(error);
        _this.onError(error);
      });
    },
    searchUser(){
      var _this = this;
      // Ohne encodeURIComponent zerlegte ein Suchbegriff mit "/" oder "?" den
      // Pfad — die Anfrage traf dann keine Route mehr (404).
      //
      // Diese Abfrage ERSETZT die Liste (users = ..., nicht push), also gehört
      // die Seitenzahl zurück auf Anfang — genau wie in fetchUser(). Bisher
      // verließ sich das darauf, dass der Beobachter am Suchfeld page vorher
      // setzt; jeder andere Aufrufer (siehe reloadUsers) hätte mit einer alten
      // Seitenzahl gesucht. `page` steht hier zugleich als skip in der Adresse.
      this.page = 0;
      this.loading = true;
      this.fetchError = '';
      this.$axios.get('/user/blacklist/search/' + encodeURIComponent(this.search) +'/'+ this.page + '/' + this.ElementPerPage + '/' + this.getCurrentTimeSpan()).then(function(response){
        _this.loading = false;
        if (response.data == null || response.data.success === false) {
          _this.users = [];
          _this.lastUsers = 0;
          _this.fetchError = (response.data && response.data.message) || 'Der Server hat die Anfrage abgelehnt.';
          return;
        }
        _this.users = response.data.data || [];
        _this.lastUsers = _this.users.length;
      }).catch(function(error){
        _this.loading = false;
        // Siehe fetchUser(): Die alte Liste blieb im Fehlerfall stehen und
        // stand dann zusammen mit der Fehlerzeile auf dem Bildschirm.
        _this.users = [];
        _this.lastUsers = 0;
        _this.fetchError = _this.serverMessage(error);
        _this.onError(error);
      });
    },
    // Liefert AUSSCHLIESSLICH den Klartext, den der Server geschickt hat —
    // sonst null. Zwei Formen: Axios-Fehler (Text in err.response.data) und
    // der Antwortkörper eines fachlichen Fehlschlags ({success:false,
    // message:"…"} mit HTTP 200), den die schreibenden Aktionen direkt
    // hereinreichen. Bewusst NICHT err.message eines Axios-Fehlers: Das ist
    // der technische englische Text ("Network Error"). Wie in Users.vue.
    failureMessage(err) {
      if (err == null) return null;
      if (err.response != null && err.response.data != null && err.response.data.message) {
        return err.response.data.message;
      }
      if (err.response == null && err.success === false && err.message) {
        return err.message;
      }
      return null;
    },
    // Liefert einen anzeigbaren Text zu einem fehlgeschlagenen Abruf, für die
    // Fehlerzeile in der Tabelle. Gleiches Muster wie in Crews.vue/Users.vue.
    serverMessage(error, fallback) {
      return this.failureMessage(error) || fallback || 'Die Anfrage ist fehlgeschlagen.';
    },
    onError(err) {
      if (err != null && err.response != null && err.response.data != null) {
        // this.console gibt es nicht — der Fehlerbehandler warf hier selbst
        // und verdeckte damit die eigentliche Ursache.
        console.error(err.response.data);
      } else {
        console.error(err);
      }
      // WAR FALSCH: Dieser Behandler schrieb nur in die Entwicklerkonsole.
      // Ein fehlgeschlagener Abruf sah dadurch genauso aus wie eine leere
      // Sperrliste. Bei 401/403 bleibt es bei der zentralen Meldung aus
      // main.js.
      const status = err != null && err.response != null ? err.response.status : null;
      if (status === 401 || status === 403) return;
      // WAR FALSCH: Das Freischalten reicht hier den ANTWORTKÖRPER herein
      // ({success:false, message:"…"}). Der Text darin ging verloren und der
      // Verwalter las nur "Etwas ist schief gelaufen" — ohne den Grund.
      const message = this.failureMessage(err);
      if (message) {
        this.$noty.error(message);
        return;
      }
      this.$showCommonError();
    },
    openDeleteUser(user) {
      this.deleteDialog = true;
      this.editUser = user;
    },
    deleteUser() {
      let _this = this;
      this.$axios.get('user/blacklist/delete/' + this.editUser._id).then(function(response){
        // WAR FALSCH: response.data.success wurde nicht geprüft. respondFailure
        // antwortet mit HTTP 200 und success:false — der Dialog ging trotzdem
        // zu und meldete stillschweigend Erfolg, auch wenn nichts freigeschaltet
        // wurde (etwa weil das Konto zwischenzeitlich schon entfernt wurde).
        if (response.data != null && response.data.success === false) {
          _this.onError(response.data);
          return;
        }
        _this.deleteDialog = false;
        // WAR FALSCH: Hier stand fest fetchUser() — das holt IMMER die
        // ungefilterte Gesamtliste. Wer nach einem Namen gesucht und den einen
        // Treffer freigeschaltet hat, fand danach seinen Begriff weiter im
        // Suchfeld, darunter aber alle gesperrten Nutzer. Es sah aus, als hätte
        // sich die Suche von selbst zurückgesetzt. Gleiche Lösung wie
        // reloadUsers() in Users.vue und reloadModels() in UserAutos.vue.
        _this.reloadUsers();
      }).catch(function(error){
        _this.onError(error);
      })
    },
    // Lädt die Liste so neu, wie sie gerade angezeigt wird: mit Suchbegriff
    // wird gesucht, ohne wird die volle Sperrliste geholt. Beide Methoden
    // setzen page selbst auf 0 zurück.
    reloadUsers() {
      if (this.search == null || this.search === "") {
        this.fetchUser();
      } else {
        this.searchUser();
      }
    },
  setTimePicker(timeSpan) {
      console.log(timeSpan);
           let currentId = 'dropdown' + this.currentTimeSpan;
           let newId = 'dropdown' + timeSpan;

           document.getElementById(currentId).classList.remove('active');
           document.getElementById(newId).classList.add('active');

           this.currentTimeSpan = timeSpan;
           this.setCurrentTimeSpan(timeSpan);
       },
    setCurrentTimeSpan(timeSpan) {
      this.currentTimeSpan = timeSpan;
      this.fetchUser();
    },
    getCurrentTimeSpan() {
      let time = -1;
      if(this.currentTimeSpan == 'Today') {
          time = 1;
      } else if (this.currentTimeSpan == 'LastWeek') {
          time = 7;
      } else if (this.currentTimeSpan == 'LastMonth') {
          time = 30;
      } else if (this.currentTimeSpan == 'AllTime') {
          time = -1;
      }

      return time;
    }
  },
};
</script>

<style scoped>
.v-dialog > .v-card > .v-card__actions {
  padding: 8px 16px;
}
</style>

